import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-table/dist/bootstrap-table.min.css'

import './jquery.js'
import Vue from 'vue'
import 'bootstrap'
import 'bootstrap-table/dist/bootstrap-table.js'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'


import 'jquery-treegrid/css/jquery.treegrid.css'
import 'jquery-treegrid/js/jquery.treegrid.min.js'
import 'bootstrap-table/dist/extensions/treegrid/bootstrap-table-treegrid.js'


Vue.component('BootstrapTable', BootstrapTable)


// WEBPACK FOOTER //
// ./src/plugins/table.js